module.exports = __webpack_public_path__ + "static/bush1-7f5c1fc1b93e567fbbc99c4291210f81.png";